
// DatepickerField.js

import React from 'react';

function DatepickerField({ value, onChange }) {
  // Manipulador de mudança de data
  const handleDateChange = (e) => {
    // Chamar a função de mudança de prop com o valor da data
    onChange(e.target.value);
  };

  return (
    <input
      type="date"
      value={value}
      onChange={handleDateChange}
      style={{
        width: '120px',
        height: '30px',
        border: '1px solid black',
        marginBottom: '0px',
        fontSize: '16px', // Ajustar o tamanho da fonte conforme necessário
      }}
    />
  );
}

export default DatepickerField;